import Cloudy from '../assets/img/weather/cloudy.svg';
import Fog from '../assets/img/weather/fog.svg';
import Overcast from '../assets/img/weather/overcast.svg';
import Rain from '../assets/img/weather/rain.svg';
import Snow from '../assets/img/weather/snow.svg';
import Sunny from '../assets/img/weather/sunny.svg';
import Thunderstorm from '../assets/img/weather/thunderstorm.svg';

const wmoCodeToEmojiMap = {
  0: Sunny, // Clear sky
  1: Cloudy, // Mainly clear
  2: Cloudy, // Partly cloudy
  3: Overcast, // Overcast
  45: Fog, // Fog
  48: Fog, // Depositing rime fog
  51: Rain, // Drizzle: Light intensity
  53: Rain, // Drizzle: Moderate intensity
  55: Rain, // Drizzle: Dense intensity
  56: Rain, // Freezing Drizzle: Light intensity
  57: Rain, // Freezing Drizzle: Dense intensity
  61: Rain, // Rain: Slight intensity
  63: Rain, // Rain: Moderate intensity
  65: Rain, // Rain: Heavy intensity
  66: Rain, // Freezing Rain: Light intensity
  67: Rain, // Freezing Rain: Heavy intensity
  71: Snow, // Snow fall: Slight intensity
  73: Snow, // Snow fall: Moderate intensity
  75: Snow, // Snow fall: Heavy intensity
  77: Snow, // Snow grains
  80: Rain, // Rain showers: Slight intensity
  81: Rain, // Rain showers: Moderate intensity
  82: Rain, // Rain showers: Violent intensity
  85: Snow, // Snow showers: Slight intensity
  86: Snow, // Snow showers: Heavy intensity
  95: Thunderstorm, // Thunderstorm: Slight or moderate
  96: Thunderstorm, // Thunderstorm with slight hail
  99: Thunderstorm, // Thunderstorm with heavy hail
} as Record<number, string>;

export const wmoCodeToIconSrc = (wmoCode: number): string => {
  return wmoCodeToEmojiMap[wmoCode] || ``;
};
